import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { LocationStrategy, PathLocationStrategy } from "@angular/common";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CookieService } from "ngx-cookie-service";
import { AuthGuardService } from "./services/auth/auth-guard.service";
import { HttpTokenInterceptor } from "./interceptors/token.interceptor";
import { MessagesInterceptor } from "./interceptors/messages.interceptor";
import { ProfileResolver } from "./resolvers/profile.resolver";

import { AppComponent } from "./app.component";
import { LoaderComponent } from "@app/components/loader/loader.component";

import { environment } from "../environments/environment";

// Import containers
const APP_CONTAINERS = [LoaderComponent];

import {
  AvatarModule,
  BreadcrumbModule,
  FooterModule,
  GridModule,
  HeaderModule,
  SidebarModule,
  DropdownModule,
  NavModule,
  UtilitiesModule,
  ButtonModule,
} from "@coreui/angular";
import { IconModule } from "@coreui/icons-angular";

// Import routing module
import { AppRoutingModule } from "./app.routing";

// Import 3rd party components
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TabsModule } from "ngx-bootstrap/tabs";
import { ToastrModule } from "ngx-toastr";
import { LoaderInterceptor } from "./interceptors/loader.interceptor";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { ModalModule } from "ngx-bootstrap/modal";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { getFirestore, provideFirestore } from "@angular/fire/firestore";
import { provideAuth } from "@angular/fire/auth";
import { getAuth } from "firebase/auth";
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFirestoreModule } from "@angular/fire/compat/firestore";
import { AlertModule } from "ngx-bootstrap/alert";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PaginationConfig } from "ngx-bootstrap/pagination";
// import { StoreModule } from "@ngrx/store";
// import { reducers, metaReducers } from "./store/request.index";
// import { EffectsModule } from "@ngrx/effects";
// import { RequestEffects } from "./store/effects/request.effect";

@NgModule({
  declarations: [AppComponent, ...APP_CONTAINERS],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AvatarModule,
    BreadcrumbModule,
    FooterModule,
    GridModule,
    HeaderModule,
    SidebarModule,
    DropdownModule,
    NavModule,
    UtilitiesModule,
    ButtonModule,
    IconModule,
    // PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    // provideFirebaseApp(() => initializeApp(environment.firebase)),
    // provideAuth(() => getAuth()),
    // provideFirestore(() => getFirestore()),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    AlertModule.forRoot(),
    NgbModule,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MessagesInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    CookieService,
    AuthGuardService,
    ProfileResolver,
    provideHttpClient(withInterceptorsFromDi()),
    // Paginations that don't set [maxSize] used to render every page number, which ran off the
    // screen on phones once a list had a few hundred rows.
    {
      provide: PaginationConfig,
      useFactory: () => {
        const config = new PaginationConfig();
        config.main = { ...config.main, maxSize: 5 };
        return config;
      },
    },
  ],
})
export class AppModule {}
